<template>
  <v-card-actions class="pa-sm-8 pt-6 pa-4 d-flex justify-center">
    <ProductAddToProject
      v-if="isNeedToShowAddToProjectButton"
      :item="item">
      <template #buttonWrapper="{ btnText }">
        <v-btn
          class="mt-3"
          outlined
          color="lightBlue">
          {{ btnText }}
        </v-btn>
      </template>
    </ProductAddToProject>
    <div class="px-0">
      <app-btn
        v-if="isHideDeleteButton"
        class="mt-3 ml-3"
        show-tooltip
        bottom
        :access="canModifyOwnProduct"
        color="mainRed"
        @click="$emit('delete-current-product')">
        delete
      </app-btn>
      <ProductDuplicateV2
        v-if="isFollowButtonVisible"
        :duplicate-type="TYPE_FOLLOW"
        :is-store-product-preload="isStoreProductPreload"
        :product-from-menu="item"
        :user-role="findUserRoleInLibraryForActiveHeader"
        :duplicated-collection-id="followedCollectionId"
        :duplicated-product-ids="[productId]">
        <template #duplicateButton="{ disableAction, btnText, loading }">
          <div class="d-flex">
            <app-btn
              bottom
              :disabled="disableAction"
              show-tooltip
              color="lightBlue"
              class="mt-3 ml-3"
              :loading="loading"
              outlined>
              {{ btnText }}
            </app-btn>
          </div>
        </template>
      </ProductDuplicateV2>
    </div>
    <template v-if="!isReadOnlyModalVariant">
      <v-btn
        outlined
        color="lightBlue"
        @click="$emit('show-product-modal', false)">
        Cancel
      </v-btn>
      <app-btn
        v-if="isEditModalRelatedVariant || isUserCanEditProduct"
        bottom
        btn-class="ml-3"
        :disabled="disabledEditMode"
        :access="canModifyOwnProduct"
        :show-tooltip="!canModifyOwnProduct.allowed"
        color="lightBlue"
        @click="$emit('save')">
        Update
      </app-btn>
      <v-btn
        v-else
        :disabled="isDisabledCreateButton"
        color="lightBlue"
        @click="$emit('save')">
        Save
      </v-btn>
    </template>
    <template v-else-if="isReadOnlyModalVariant && !$route.path.includes('/shared')">
      <ProductDuplicateV2
        v-if="hasAccessToProduct || isUserCanEditProduct || showAllActionsForCollectionFollower"
        :is-store-product-preload="isStoreProductPreload"
        :duplicate-type="TYPE_DUPLICATE"
        :user-role="findUserRoleInLibraryForActiveHeader"
        :duplicated-collection-id="followedCollectionId"
        :product-from-menu="item"
        :duplicated-product-ids="[productId]">
        <template #duplicateButton="{ disableAction, btnText }">
          <div class="d-flex">
            <app-btn
              bottom
              :disabled="disableAction"
              show-tooltip
              color="lightBlue"
              class="mt-3 ml-3"
              :loading="showSpinner"
              outlined>
              {{ btnText }}
            </app-btn>
          </div>
        </template>
      </ProductDuplicateV2>
      <ProductDuplicateV2
        :duplicate-type="TYPE_FOLLOW"
        :is-store-product-preload="isStoreProductPreload"
        :product-from-menu="item"
        :user-role="findUserRoleInLibraryForActiveHeader"
        :duplicated-collection-id="followedCollectionId"
        :duplicated-product-ids="[productId]">
        <template #duplicateButton="{ disableAction, btnText, loading }">
          <div class="d-flex">
            <app-btn
              bottom
              :disabled="disableAction"
              show-tooltip
              color="lightBlue"
              class="mt-3 ml-3"
              :loading="loading"
              outlined>
              {{ btnText }}
            </app-btn>
          </div>
        </template>
      </ProductDuplicateV2>
      <app-btn
        v-if="hasAccessToProduct || isUserCanEditProduct || showAllActionsForCollectionFollower"
        :access="showAllActionsForCollectionFollower ? showAllActionsForCollectionFollowerAccessDetails :canModifyOwnProduct "
        color="lightBlue"
        :show-tooltip="showAllActionsForCollectionFollower"
        bottom
        btn-class="mt-3 ml-3"
        :loading="showSpinner"
        @click="$emit('changeToEdit')">
        Edit
      </app-btn>
    </template>
  </v-card-actions>
</template>
<script>
import ProductAddToProject from '@/components/Product/ProductAddToProject/index.vue';
import ProductDuplicateV2 from '@/components/Product/ProductDuplicateV2/index.vue';
import DisableEditMode from '@/mixins/DisableEditMode';
import {
  mapGetters, mapState,
} from 'vuex';
import {
  TYPE_DUPLICATE, TYPE_FOLLOW, SHARED_COLLECTION_PAGE_NAME,
} from '@/constants';
export default {
  name: 'DialogActions',
  components: {
    ProductAddToProject,
    ProductDuplicateV2,
  },
  mixins: [DisableEditMode],
  props: {
    item: {
      type: Object,
      default: null,
    },
    canWorkWithModifyProduct: {
      type: Object,
      default: () => {
      },
    },
    selectedCollectionToCreateProduct: {
      type: Object,
      default: null,
    },
    hasAccessToProduct: {
      type: Boolean,
      default: false,
    },
    productId: {
      type: String,
      default: '',
    },
    followedCollectionId: {
      type: String,
      default: '',
    },
    isStoreProductPreload: {
      type: Boolean,
      default: false,
    },
    userRoleInCollection: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      TYPE_DUPLICATE,
      TYPE_FOLLOW,
    };
  },
  computed: {
    ...mapState(['showSpinner', 'activeHeader']),
    ...mapGetters('Collections', ['isReadOnlyModalVariant', 'isEditModalVariant', 'isAddModalVariant', 'isUpdateReferencedProduct']),
    ...mapGetters({
      isActiveUserGuestInWorkspace: 'Workspace/isActiveUserGuestInWorkspace',
      findUserRoleInLibraryForActiveHeader: 'UserRoles/findUserRoleInLibraryForActiveHeader',
    }),
    isNeedToShowAddToProjectButton() {
      const { isActiveUserGuestInWorkspace: isUserGuest } = this;
      if (isUserGuest) return true;
      const { follow: followActiveHeader = false } = this.activeHeader ?? {
      };
      const { name = '' } = this.$route ?? {
      };
      return this.isReadOnlyModalVariant && (this.hasAccessToProduct || followActiveHeader || name == 'collections');
    },
    isDisabledCreateButton() {
      return (this.isAddModalVariant || this.isSaveAsNewVariant) && !this.selectedCollectionToCreateProduct?.id;
    },
    isSharedCollectionPage() {
      const { name = '' } = this.$route ?? {
      };
      return SHARED_COLLECTION_PAGE_NAME === name;
    },
    isHideDeleteButton() {
      return !this.isSharedCollectionPage && (this.isReadOnlyModalVariant && (this.hasAccessToProduct || this.isUserCanEditProduct || this.showAllActionsForCollectionFollower));
    },
    isFollowButtonVisible() {
      return this.isSharedCollectionPage;
    },
    isEditModalRelatedVariant() {
      const { isEditModalVariant, isUpdateReferencedProduct } = this;
      return isEditModalVariant || isUpdateReferencedProduct;
    },
    isUserCanEditProduct() {
      return ['creator', 'editor', 'owner'].includes(this.userRoleInCollection);
    },
    canModifyOwnProduct() {
      if (this.isUserCanEditProduct) {
        return {
          allowed: true,
        };
      } else {
        return this.canWorkWithModifyProduct;
      }
    },
    showAllActionsForCollectionFollower() {
      return this.findUserRoleInLibraryForActiveHeader === 'follower';
    },
    showAllActionsForCollectionFollowerAccessDetails() {
      return {
        allowed: false,
        reason: 'product_is_in_followed_collection',
      };
    },
  },
};
</script>
<style scoped lang="scss">
.add-product-modal {
  margin-left: auto;
}
.items-wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  min-height: 660px;
}
::v-deep .item-wrapper {
  margin-top: 20px;
  height: auto;
}
.items {
  display: flex;
  flex-direction: column;
}
::v-deep .v-application p {
  margin-bottom: 0px !important;
}
.required-field {
  color: red;
}
::v-deep.v-btn {
  width: 154px;
}
</style>
